export default __webpack_public_path__ + "static/media/jungle.98fb9cf2.mp3";